import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { useState } from "react";
import defaultThumbnail from "@assets/thumbnails/project-thumbs/project-thumbnail_default.svg";

/**
 * The default thumbnail image to use if no fallback source is passed.
 * We use the the default project image since project entities are the most used entities,
 * and also because the image is generic and can be used for other entities as well.
 */
const defaultThumbnailImage = defaultThumbnail;
/**
 * Image that falls back to a default when the source cannot be loaded.
 *
 * The backend can return a URL without checking that the underlying blob exists,
 * so a non-empty src is not a guarantee that the image can be displayed.
 */
export function ThumbnailImage(t0) {
  const $ = _c(8);
  const {
    src,
    fallbackSrc: t1,
    alt: t2,
    sx
  } = t0;
  const fallbackSrc = t1 === undefined ? defaultThumbnailImage : t1;
  const alt = t2 === undefined ? "Thumbnail image" : t2;
  const [failedSrc, setFailedSrc] = useState(null);
  const shouldUseFallback = !src || src === failedSrc;
  const t3 = shouldUseFallback ? fallbackSrc : src;
  let t4;
  if ($[0] !== shouldUseFallback || $[1] !== src) {
    t4 = () => !shouldUseFallback && setFailedSrc(src);
    $[0] = shouldUseFallback;
    $[1] = src;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== alt || $[4] !== sx || $[5] !== t3 || $[6] !== t4) {
    t5 = <Box component="img" src={t3} alt={alt} loading="lazy" onError={t4} sx={sx} />;
    $[3] = alt;
    $[4] = sx;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}